export { preloadPostOfficeConfluenceHomeBanner } from '../src/preloadConfluenceHomeBanner.ts';
